<script setup lang="ts">
  import dayjs from 'dayjs'
  import PlaneLoader from '@/components/ui/PlaneLoader.vue'
  import { useSherpaWidget } from '@/composables/widgets/sherpa/useSherpa'
  import type { TPlacement } from '@/components/widgets/types'
  import type { INearestAirport } from '@/types/OrigDest'

  const props = withDefaults(
    defineProps<{
      placement: TPlacement
      origin: string
      destin: string
      departure: string
    }>(),
    {
      placement: 'homePage',
      origin: '',
      destin: '',
      departure: ''
    }
  )

  const localeStore = useLocaleStore()
  const nearestAirportData = useCookie<INearestAirport>('nearestAirportData')
  const flight = computed(() => {
    const data = {
      segmentType: 'OUTBOUND',
      origin: {
        airportCode: props.origin || nearestAirportData.value?.code || 'RIX'
      },
      departureDate: props.departure || dayjs().format('YYYY-MM-DD')
    } as {
      segmentType: string
      origin: { airportCode: string }
      destination?: { airportCode: string }
      departureDate: string
    }

    if (props.destin) {
      data.destination = { airportCode: props.destin }
    }

    return data
  })
  const showResults = computed(() => !!props.destin)
  const WIDGET_SELECTOR = 'sherpa-widget'

  useSherpaWidget({
    widgetConfig: {
      placement: props.placement,
      defaultNationality: localeStore.selectedCountry,
      segments: [flight.value],
      features: {
        showResults: showResults.value
      }
    },
    widgetSelector: WIDGET_SELECTOR,
    widgetType: 'trip'
  })
</script>

<template>
  <div :id="WIDGET_SELECTOR">
    <div class="flex h-40 w-full items-center justify-center">
      <PlaneLoader />
    </div>
  </div>
</template>
